/**
 * In-memory: auto location+store resolve ran successfully this app session.
 * Cleared on cold start; optional reset on logout.
 */
let autoLocationResolved = false;

export function hasAutoLocationResolved() {
  return autoLocationResolved;
}

export function markAutoLocationResolved() {
  autoLocationResolved = true;
}

export function resetAutoLocationSession() {
  autoLocationResolved = false;
}
